
    import RexGraph from './RexGraph.svelte'

    new RexGraph({target: document.getElementById('RexGraph')})
